import { render, staticRenderFns } from "./land-around-cards.vue?vue&type=template&id=e7823a30"
import script from "./land-around-cards.vue?vue&type=script&lang=js"
export * from "./land-around-cards.vue?vue&type=script&lang=js"
import style0 from "./land-around-cards.vue?vue&type=style&index=0&id=e7823a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports